/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { FC, useEffect } from "react"
import { PreviewPhone } from "components/previews/PreviewPhone"
import { MenuStoreList } from "pages/menu"
import { MenuPreview } from "components/previews"
import { MerchantStoreInfo } from "types/models/menu"
import { useIsMartMenuGroup } from "pages/menu-groups/useIsMartMenuGroup"
import { useTranslationsMap } from "common/utils/i18n"
import { TroyWebTracker } from "utils/tracking"
import { EventAction, EventCategory } from "constants/tracking"
import { useSelector } from "react-redux"
import { AppState } from "store/store.type"
import { reviewPublishStyle } from "../style"

interface ReviewPublishProps {
  selectedStores: MerchantStoreInfo[]
}

export const ReviewPublish: FC<ReviewPublishProps> = ({
  selectedStores,
}: ReviewPublishProps) => {
  const isMartMenuGroup = useIsMartMenuGroup()

  const {
    menu: {
      menuGroupDetail: { menuGroupID },
      merchantGroupID,
    },
  } = useSelector((state: AppState) => state)

  const textAsBizType = isMartMenuGroup ? "forCatalogue" : "forMenu"
  const textMap = useTranslationsMap({
    titleOneStore: `menu.menuGroup.create.${textAsBizType}.willBePublishedToOneStore`,
    titleMultipleStore: `menu.menuGroup.create.${textAsBizType}.willBePublishedToXStore`,
  })

  const onMount = () => {
    TroyWebTracker.sendEvent({
      category: EventCategory.menuGroupCreationReview,
      action: EventAction.pageView,
      labels: {
        MERCHANT_GROUP_ID: merchantGroupID,
        MENU_GROUP_ID: menuGroupID,
      },
    })
  }

  useEffect(onMount, [])

  const title =
    selectedStores?.length === 1
      ? textMap.titleOneStore
      : textMap.titleMultipleStore.replace(
          "<x>",
          selectedStores.length.toString(),
        )
  return (
    <div css={reviewPublishStyle}>
      <PreviewPhone>
        <MenuPreview />
      </PreviewPhone>
      <MenuStoreList
        className="store-list"
        title={title}
        hideSearchBox
        outletsOverride={selectedStores}
        onRowClickOverride={() => {}}
        hideStoreNameArrowRight
        eventCategory={EventCategory.menuGroupCreationReview}
      />
    </div>
  )
}
